import { render, staticRenderFns } from "./OrderViewCancellationPolicies.vue?vue&type=template&id=4cba5aed&scoped=true&"
import script from "./OrderViewCancellationPolicies.vue?vue&type=script&lang=js&"
export * from "./OrderViewCancellationPolicies.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewCancellationPolicies.vue?vue&type=style&index=0&id=4cba5aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba5aed",
  null
  
)

export default component.exports